<template>
    <div class="main">
        <div class="contain">
            <a-card
                    hoverable
                    title="编辑资料"
                    class="userinfo"
                    :bordered="false">
                <a-form
                        :form="form"
                        @submit="save"
                >
                    <a-form-item label="姓名">
                        <a-input
                                v-decorator="[
                                  'param.name',
                                  {
                                  rules: [{ required: true, message: '姓名不能为空' }],
                                  initialValue:param.name
                                  }
                                ]"
                        />
                    </a-form-item>
                    <a-form-item label="旧密码">
                        <a-input
                                placeholder="请输入旧密码"
                                v-decorator="[
                                  'oldPass',
                                  {rules: [{ required: true, message: '旧密码不能为空' }],}
                                ]"
                                type="password"
                        />
                    </a-form-item>
                    <a-form-item label="新密码">
                        <a-input
                                placeholder="不修改密码请留空"
                                v-decorator="[
                                    'newPass1',
                                    {rules: [
                                        {validator: validateToNextPassword}
                                    ]}
                                ]"
                                :type="password"
                        >
                            <icon-font
                                    slot="suffix"
                                    type="iconicon-test1"
                                    style="font-size: 24px;"
                                    v-if="password == 'password'"
                                    @click="()=>{this.password='text'}"
                            />
                            <icon-font
                                    v-else
                                    slot="suffix"
                                    type="iconicon-test"
                                    style="font-size: 24px;"
                                    @click="()=>{this.password='password'}"
                            />
                        </a-input>

                    </a-form-item>
                    <a-form-item label="重复新密码" v-if="typeof form.getFieldValue('newPass1') != 'undefined'">
                        <a-input placeholder="请重复输入新密码"
                                 v-decorator="[
                                  'newPass2',
                                      {rules: [
                                            {required: true, message: '请确认密码'},
                                            {validator: compareToFirstPassword}
                                        ]}
                                    ]"
                                 :type="password"
                                 @blur="handleConfirmBlur"
                        />
                    </a-form-item>
                    <a-form-item label="手机号">
                        <a-input
                                v-decorator="[
                                  'param.mobile',
                                  {rules: [{ required: true, message: '手机号不能为空' }],}
                                ]"/>
                    </a-form-item>
                    <div class="handle">
                        <a-button
                                type="primary"
                                html-type="submit"
                        >
                            保存
                        </a-button>
<!--                        <a-button type="primary" @click="save()">保存</a-button>-->
                    </div>
                </a-form>

            </a-card>
        </div>
    </div>
</template>

<script>
    import { Icon } from 'ant-design-vue';
    const IconFont = Icon.createFromIconfontCN({
        scriptUrl: '//at.alicdn.com/t/font_1391373_suybzs2x9f.js',
    })

    import moment from 'moment';
    export default {
        name: "EditUser",
        components: {
            IconFont,
        },
        data(){
            return {
                param:{
                    name: '',
                    passwd: '',
                    newpass: '',
                    mobile: ''
                },
                password: 'password',
                oldPass: '',
                newPass1: '',
                newPass2: '',
                form: this.$form.createForm(this),
                confirmDirty: false,

            }
        },
        created(){
            this.getUserInfo()
        },
        methods:{
            moment,
            handleConfirmBlur  (e) {
                const value = e.target.value;
                this.confirmDirty = this.confirmDirty || !!value;
            },
            compareToFirstPassword  (rule, value, callback) {
                const form = this.form;
                if (value && value !== form.getFieldValue('newPass1')) {
                    callback('两次密码输入不一致');
                } else {
                    console.log('ok')
                    callback();
                }
            },
            validateToNextPassword  (rule, value, callback) {
                const form = this.form;
                if (value && this.confirmDirty) {
                    form.validateFields(['newPass2'], { force: true });
                }
                callback();
            },
            getUserInfo(){
                let siteinfo = JSON.parse(window.localStorage.getItem('siteinfo'))
                this.$http.post('/api/ucenter/userdetail',{id:siteinfo.userid})
                    .then(res=>{
                        if (res.data.state == 200) {
                            let userinfo = res.data.data
                            this.param.name = userinfo.truename
                            this.param.mobile = userinfo.mobile
                        }
                    })
            },
            save(e){
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let data = {}
                        data.passwd = this.form.getFieldValue('oldPass')
                        if (typeof this.form.getFieldValue('newPass1') != 'undefined' && this.form.getFieldValue('newPass1') != '')  data.newpass = this.form.getFieldValue('newPass1')
                        data.name = this.form.getFieldValue('param.name')
                        data.mobile = this.form.getFieldValue('param.mobile')
                        this.$http.post('/api/ucenter/userupdate', data)
                            .then(res=>{
                                if (res.data.state == 200) {
                                    this.$message.success('操作成功')
                                } else {
                                    this.$message.warn('操作失败。' + res.data.message)
                                }
                            })
                     }
                });
            }
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 40px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .contain {
        margin-top: 2px;
        position: absolute;
        /*padding: 10px 0 0 10px;*/
        top: 0;
        left: 0;
        right: 0;
        bottom: 5px;
        overflow: hidden;
    }
    .contain .userinfo {
        margin: 20px auto;
        width: 800px;
    }
    .contain .userinfo>>>.ant-card-head-title{
        padding-left: 20px;
    }
    .contain .userinfo>>>.ant-card-body{
        padding: 20px;
    }
    .ant-form-item {
        margin: 0;
    }
    .handle {
        margin-top: 20px;
        text-align: right;
    }
    .handle button {
        margin-left: 20px;
    }
</style>